// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"demo_button-module--ctaButton--1DrlH"};